export const geoLockingEnabled = String(process.env.GATSBY_GEO_LOCKING_ENABLED).toLowerCase() === "true"
